

angular
.module('inkfinder')
.factory('ProcessSchedule', function ProcessSchedule(
  Session,
  moment,
  _
) {
  // Public methods
  ProcessSchedule.process = process;

  /**
   * @name process
   * @description Preprocess the Data before Parsing the Schedule.
   * @param {unknown} input Unknown
   * @param {unknown} day Unknown
   * @return {unknown} Unknown
   */
  function process(input, day) {
    let data = _.cloneDeep(input);
    let output = [];

    _.each(data, function(hours) {
      let processed = hours;
      processed.temp = {};
      processed.display = {};

      // Convert Moment Object to String (From the Form as a Moment Object)
      if (_.isObject(hours.start_time)) {
        processed.start_time = moment(hours.start_time).format('HH:mm:ss');
      } else {
        processed.temp.raw_start_time = moment(hours.start_time, 'HH:mm:ss');
      }

      // Convert Moment Object to String (From the Form as a Moment Object)
      if (_.isObject(hours.end_time)) {
        processed.end_time = moment(hours.end_time).format('HH:mm:ss');
      } else {
        processed.temp.raw_end_time = moment(hours.end_time, 'HH:mm:ss');
      }

      // Convert Moment Object to String
      if (hours.start_date) {
        processed.temp.raw_start_date =
        moment(hours.start_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
        processed.display.start_date = moment(hours.start_date);
      }

      // Convert Moment Object to String
      if (hours.end_date) {
        processed.temp.raw_end_date =
        moment(hours.end_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
        processed.display.end_date = moment(hours.end_date);
      }
      if (day) {
        processed.display.start_time =
        moment(moment(day).format('YYYY-MM-DD') + 'T' +
        hours.start_time, 'YYYY-MM-DDTHH:mm:ss');
        processed.display.end_time =
        moment(moment(day).format('YYYY-MM-DD') + 'T' +
        hours.end_time, 'YYYY-MM-DDTHH:mm:ss');
      }
      if (hours.start_date && hours.end_date) {
        let start_datetime =
        moment(hours.start_date + 'T' + hours.start_time, 'YYYY-MM-DDTHH:mm:ss');
        let end_datetime = moment(hours.end_date + 'T' + hours.end_time, 'YYYY-MM-DDTHH:mm:ss');
        if (end_datetime.unix() <= start_datetime.unix()) {
          processed.end_date =
          moment(hours.end_date).add(1, 'day').format('YYYY-MM-DD');
        }
      }
      if (hours.is_off) {
        processed.temp.raw_end_date =
        moment(hours.end_date, 'YYYY-MM-DD')
        .subtract(1, 'day').format('MM/DD/YYYY');
        processed.display.end_date = moment(hours.end_date).subtract(1, 'day');

        let daysInSeconds =
        Math.abs(moment(hours.start_date).unix() -
        moment(hours.end_date).unix());
        if (daysInSeconds / 86400 <= 1) {
          processed.date_override = true;
        }
      }
      output.push(processed);
    });
    return output;
  }
  return ProcessSchedule;
});



// WEBPACK FOOTER //
// ./components/schedule/util/process-schedule.service.js